// Theme: cherry-lacquer
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'cherry-lacquer',
  name: 'CHERRY LACQUER',
  tagline: 'CHERRY LACQUER',
  description: 'Laca cereja com brilho radial e contraste suave.',
  category: 'system-core',
  tier: 'rare',
  basePrice: 2625,
  swatches: ['#2A0A14', '#3D1020', '#E07A9B', '#F7D7E2'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '10px',
      '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)'
    },
    shellClasses: 'font-mono theme-cherry-lacquer'
  },
  colorVars: {
    '--accent': '#E07A9B',
    '--accent-foreground': '#2A0A14',
    '--background': '#2A0A14',
    '--border': '#8B1E3F',
    '--card': '#3D1020',
    '--card-border-active': 'rgba(224, 122, 155, 0.45)',
    '--card-completed': '#30101A',
    '--card-foreground': '#F7D7E2',
    '--card-glow': 'rgba(224, 122, 155, 0.08)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--foreground': '#F7D7E2',
    '--hold-fill': '#E07A9B',
    '--input': '#8B1E3F',
    '--modal-bg': '#2A0A14',
    '--modal-border': '#8B1E3F',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#8B1E3F',
    '--muted-foreground': '#F7D7E2',
    '--nav-active': '#E07A9B',
    '--nav-bg': '#3D1020',
    '--popover': '#3D1020',
    '--popover-foreground': '#F7D7E2',
    '--primary': '#E07A9B',
    '--primary-foreground': '#2A0A14',
    '--ring': '#E07A9B',
    '--secondary': '#8B1E3F',
    '--secondary-foreground': '#F7D7E2',
    '--streak': '#E07A9B',
    '--success': '#22c55e',
    '--success-foreground': '#2A0A14',
    '--xp': '#E07A9B',
    '--xp-bg': '#3D1020'
  },
  resolvedVars: {
    '--accent': '#E07A9B',
    '--accent-foreground': '#2A0A14',
    '--accent-foreground-hsl': '341 62% 10%',
    '--accent-foreground-oklch': 'from #2A0A14 l c h',
    '--accent-hsl': '341 62% 68%',
    '--accent-oklch': 'from #E07A9B l c h',
    '--background': '#2A0A14',
    '--background-hsl': '341 62% 10%',
    '--background-oklch': 'from #2A0A14 l c h',
    '--border': '#8B1E3F',
    '--border-hsl': '342 64% 33%',
    '--border-oklch': 'from #8B1E3F l c h',
    '--border-w': '1px',
    '--card': '#3D1020',
    '--card-border-active': 'rgba(224, 122, 155, 0.45)',
    '--card-completed': '#30101A',
    '--card-completed-hsl': '341 50% 13%',
    '--card-completed-oklch': 'from #30101A l c h',
    '--card-foreground': '#F7D7E2',
    '--card-foreground-hsl': '339 67% 91%',
    '--card-foreground-oklch': 'from #F7D7E2 l c h',
    '--card-glow': 'rgba(224, 122, 155, 0.08)',
    '--card-hsl': '339 58% 15%',
    '--card-oklch': 'from #3D1020 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--destructive-foreground-hsl': '0 0% 4%',
    '--destructive-foreground-oklch': 'from #0a0a0a l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F7D7E2',
    '--foreground-hsl': '339 67% 91%',
    '--foreground-oklch': 'from #F7D7E2 l c h',
    '--hold-fill': '#E07A9B',
    '--hold-fill-hsl': '341 62% 68%',
    '--hold-fill-oklch': 'from #E07A9B l c h',
    '--input': '#8B1E3F',
    '--input-hsl': '342 64% 33%',
    '--input-oklch': 'from #8B1E3F l c h',
    '--modal-bg': '#2A0A14',
    '--modal-bg-hsl': '341 62% 10%',
    '--modal-bg-oklch': 'from #2A0A14 l c h',
    '--modal-border': '#8B1E3F',
    '--modal-border-hsl': '342 64% 33%',
    '--modal-border-oklch': 'from #8B1E3F l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#8B1E3F',
    '--muted-foreground': '#F7D7E2',
    '--muted-foreground-hsl': '339 67% 91%',
    '--muted-foreground-oklch': 'from #F7D7E2 l c h',
    '--muted-hsl': '342 64% 33%',
    '--muted-oklch': 'from #8B1E3F l c h',
    '--nav-active': '#E07A9B',
    '--nav-active-hsl': '341 62% 68%',
    '--nav-active-oklch': 'from #E07A9B l c h',
    '--nav-bg': '#3D1020',
    '--nav-bg-hsl': '339 58% 15%',
    '--nav-bg-oklch': 'from #3D1020 l c h',
    '--popover': '#3D1020',
    '--popover-foreground': '#F7D7E2',
    '--popover-foreground-hsl': '339 67% 91%',
    '--popover-foreground-oklch': 'from #F7D7E2 l c h',
    '--popover-hsl': '339 58% 15%',
    '--popover-oklch': 'from #3D1020 l c h',
    '--primary': '#E07A9B',
    '--primary-foreground': '#2A0A14',
    '--primary-foreground-hsl': '341 62% 10%',
    '--primary-foreground-oklch': 'from #2A0A14 l c h',
    '--primary-hsl': '341 62% 68%',
    '--primary-oklch': 'from #E07A9B l c h',
    '--radius': '10px',
    '--ring': '#E07A9B',
    '--ring-hsl': '341 62% 68%',
    '--ring-oklch': 'from #E07A9B l c h',
    '--secondary': '#8B1E3F',
    '--secondary-foreground': '#F7D7E2',
    '--secondary-foreground-hsl': '339 67% 91%',
    '--secondary-foreground-oklch': 'from #F7D7E2 l c h',
    '--secondary-hsl': '342 64% 33%',
    '--secondary-oklch': 'from #8B1E3F l c h',
    '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)',
    '--streak': '#E07A9B',
    '--streak-hsl': '341 62% 68%',
    '--streak-oklch': 'from #E07A9B l c h',
    '--success': '#22c55e',
    '--success-foreground': '#2A0A14',
    '--success-foreground-hsl': '341 62% 10%',
    '--success-foreground-oklch': 'from #2A0A14 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(341 62% 68% / 0.15)',
    '--xp': '#E07A9B',
    '--xp-bg': '#3D1020',
    '--xp-bg-hsl': '339 58% 15%',
    '--xp-bg-oklch': 'from #3D1020 l c h',
    '--xp-hsl': '341 62% 68%',
    '--xp-oklch': 'from #E07A9B l c h'
  }
}
